import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import EastIcon from "@mui/icons-material/East";
import styles from "../../../../styles/gri/general.module.css";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import { put, get } from "../../../../utils/api";
import GRISidebar from "../../../../Layout/GRISidebar";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI201_1 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [total, setTotal] = useState({});
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    valueGeneratedCurrency: "",
    valueGenerated: {
      amount: {
        sales: "",
        revenueFinancial: "",
        revenueSale: "",
        total: "",
      },
    },
    valueDistributedCurrency: "",
    valueDistributed: {
      amount: {
        cost: "",
        empbenefits: "",
        capitalPayment: "",
        governmentPayment: "",
        community: "",
        total: "",
      },
    },
    valueRetainedCurrency: "",
    valueRetained: {
      amount: {
        directeconomic: "",
        economic: "",
        total: "",
      },
    },
  });

  const [griReview, setGriReview] = React.useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
  React.useEffect(() => {
    const handleStorage = () =>
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const inputData = [
    {
      title: "i. Direct economic value generated",
      currency: ["USD", "EUR", "INR"],
      currencyFieldName: "valueGeneratedCurrency",
      fields: [
        {
          // fieldName: "awarenessProgramHeld",
          title: "Economic Value Generated",
          subheading: "valueGenerated.amount",
          // placeholder: "Enter Number",
          // type: "number",
          width: "45rem",
        },
        {
          fieldName: "awarenessProgramHeld",
          title: "Amount",
          // placeholder: "Enter Number",
          type: "number",
          width: "45rem",
        },
      ],
    },
    {
      title: "ii. Economic value distributed",
      currency: ["USD", "EUR", "INR"],
      currencyFieldName: "valueDistributedCurrency",
      fields: [
        {
          // fieldName: "awarenessProgramHeld",
          title: "Economic Value  Distributed",
          subheading: "valueDistributed.amount",
          // placeholder: "Enter Number",
          // type: "number",
          width: "45rem",
        },
        {
          fieldName: "awarenessProgramHeld",
          title: "Amount",
          // placeholder: "Enter Number",
          type: "number",
          width: "45rem",
        },
      ],
    },
    {
      title: "iii. Economic value retained",
      currency: ["USD", "EUR", "INR"],
      currencyFieldName: "valueRetainedCurrency",
      fields: [
        {
          // fieldName: "awarenessProgramHeld",
          title: "Economic Value Retained",
          subheading: "valueRetained.amount",
          // placeholder: "Enter Number",
          // type: "number",
          width: "45rem",
        },
        {
          fieldName: "awarenessProgramHeld",
          title: "Amount",
          // placeholder: "Enter Number",
          type: "number",
          width: "45rem",
        },
      ],
    },
  ];

  const fetchData = async () => {
    await get(`/gri/get?type=GRI200&Id=${id}`).then((res) => {
      if (
        res?.data?.data?.year ? res?.data?.data?.year < currentYear - 1 : false
      )
        setDisabled(true);
      const dataGRI200 = res?.data?.data?.GRI200;
      setFormData({
        valueGeneratedCurrency: dataGRI200?.valueGeneratedCurrency,
        valueGenerated: {
          amount: {
            sales: dataGRI200?.valueGenerated?.amount?.sales,
            revenueFinancial:
              dataGRI200?.valueGenerated?.amount?.revenueFinancial,
            revenueSale: dataGRI200?.valueGenerated?.amount?.revenueSale,
            total: dataGRI200?.valueGenerated?.amount?.total,
          },
        },
        valueDistributedCurrency: dataGRI200?.valueDistributedCurrency,
        valueDistributed: {
          amount: {
            cost: dataGRI200?.valueDistributed?.amount?.cost,
            empbenefits: dataGRI200?.valueDistributed?.amount?.empbenefits,
            capitalPayment:
              dataGRI200?.valueDistributed?.amount?.capitalPayment,
            governmentPayment:
              dataGRI200?.valueDistributed?.amount?.governmentPayment,
            community: dataGRI200?.valueDistributed?.amount?.community,
            total: dataGRI200?.valueDistributed?.amount?.total,
          },
        },
        valueRetainedCurrency: dataGRI200?.valueRetainedCurrency,
        valueRetained: {
          amount: {
            directeconomic: dataGRI200?.valueRetained?.amount?.directeconomic,
            economic: dataGRI200?.valueRetained?.amount?.economic,
            total: dataGRI200?.valueRetained?.amount?.total,
          },
        },
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const defaultSegments = [
    {
      percentage: [
        { title: "Net Sales", field: "sales" },
        {
          title: "Revenues from financial investments",
          field: "revenueFinancial",
        },
        { title: "Revenues from sale of assets", field: "revenueSale" },
        { title: "Total", field: "total" },
      ],
    },
    {
      percentage: [
        { title: "Operating cost", field: "cost" },
        { title: "Employee Wages and benefits", field: "empbenefits" },
        { title: "Payments to providers of capital", field: "capitalPayment" },
        { title: "Payments to government", field: "governmentPayment" },
        { title: "Community investments", field: "community" },
        { title: "Total", field: "total" },
      ],
    },
    {
      percentage: [
        { title: "Direct economic value generated", field: "directeconomic" },
        { title: "Economic value distributed", field: "economic" },
        { title: "Total", field: "total" },
      ],
    },
  ];

  const validateForm = () => {
    let newErrors = {};

    // const validateFields = (obj, path = "") => {
    //   Object.keys(obj).forEach((key) => {
    //     const currentPath = path ? `${path}.${key}` : key;

    //     if (typeof obj[key] === "object" && obj[key] !== null) {
    //       validateFields(obj[key], currentPath);
    //     } else {
    //       if (!obj[key]) {
    //         newErrors[currentPath] = "This field is required";
    //       }
    //     }
    //   });
    // };

    // // Run validation for all fields
    // validateFields(formData);

    // Function to check if any amount field is filled but currency is empty
    const validateAmountCurrencyPair = (
      amountFields,
      currency,
      currencyKey
    ) => {
      const isAnyFieldFilled = Object.values(amountFields).some((val) => val);
      console.log(
        isAnyFieldFilled,
        currency,
        Object.values(amountFields).some((val) => val),
        "isAnyFieldFilled"
      );
      if (isAnyFieldFilled && (currency === "" || currency === undefined)) {
        newErrors[currencyKey] = "Please select a currency";
      }
    };

    // Validate `valueGenerated`
    validateAmountCurrencyPair(
      formData.valueGenerated.amount,
      formData.valueGeneratedCurrency,
      "valueGeneratedCurrency"
    );

    // Validate `valueDistributed`
    validateAmountCurrencyPair(
      formData.valueDistributed.amount,
      // formData.valueDistributedCurrency,
      "valueDistributedCurrency"
    );

    // Validate `valueRetained`
    // validateAmountCurrencyPair(
    //   formData.valueRetained.amount,
    //   formData.valueRetainedCurrency,
    //   "valueRetainedCurrency"
    // );

    setErrors(newErrors);
    console.log(newErrors, "Validation Errors");

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return; // Allow only numbers

    const [main, sub, key] = name.split(".");

    setFormData((prevState) => {
      // Clone the current state
      const updatedState = { ...prevState };
      // const currentSection = {
      //   ...updatedState[main]?.[sub],
      //   [key]: value,
      // };
      // Update the changed field

      console.log(
        main,
        sub,
        key,
        updatedState["valueGenerated"][sub].total,
        "valueGenerated",
        updatedState["valueDistributed"][sub].total,
        "keyss"
      );

      if (
        main === "valueDistributed" &&
        total?.valueDistributed + Number(value) > total?.valueGenerated
      ) {
        return prevState; // ❌ block update
      }

      updatedState[main] = {
        ...updatedState[main],
        [sub]: {
          ...updatedState[main]?.[sub],
          [key]: value,
        },
      };
      // **Calculate total dynamically based on the section**
      if (sub === "amount" && key !== "directeconomic" && key !== "economic") {
        const fieldsToSum = Object.keys(updatedState[main][sub]).filter(
          (field) => field !== "total"
        );

        const totalValue = fieldsToSum.reduce((sum, field) => {
          return sum + (parseFloat(updatedState[main][sub][field]) || 0);
        }, 0);

        updatedState[main][sub].total = totalValue.toString();

        setTotal({ ...total, [main]: totalValue });

        // // Update the total field
        // if (
        //   main === "valueDistributed" &&
        //   parseFloat(updatedState["valueDistributed"][sub].total) >
        //     (parseFloat(updatedState["valueGenerated"][sub].total) || 0)
        // ) {
        //   return prevState; // ❌ block update
        // }
      }

      if (
        sub === "amount" &&
        (key === "economic" || key === "directeconomic")
      ) {
        const economic = parseFloat(updatedState[main][sub].economic) || 0;
        const directeconomic =
          parseFloat(updatedState[main][sub].directeconomic) || 0;
        console.log(economic, directeconomic, "checking the value");
        // Validation: don't allow directeconomic > economic
        if (economic > directeconomic) {
          return prevState; // Reject update
        }

        const totalValue = [directeconomic, economic].reduce(
          (acc, curr, index) => (index === 0 ? curr : acc - curr),
          0
        );

        updatedState[main][sub].total = totalValue.toString();
        // if (
        //   main === "valueDistributed" &&
        //   parseFloat(updatedState["valueDistributed"][sub].total) >
        //     (parseFloat(updatedState["valueGenerated"][sub].total) || 0)
        // ) {
        //   return prevState; // ❌ block update
        // }
      }

      return updatedState;
    });
  };

  const handleCurrencyChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => {
      return { ...prevState, [name]: value };
    });
  };
  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return;
      try {
        await put(`/gri/update?Id=${id}`, {
          type: "GRI200",
          ...formData,
          submitted201_1: true,
        })
          .then((res) => {
            navigate(`/gri/economic-performance/201-2/${id}`);
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    } else {
      navigate(`/gri/economic-performance/201-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p
          className={styles.section_heading}
          style={{ marginBottom: hide ? "-1rem" : "0" }}
        >
          201 : Economic Performance
        </p>
      )}
      <p className={styles.main_heading} style={{ textDecoration: "none" }}>
        201-1 :{" "}
        <span className={styles.main_heading_underline}>
          Direct economic value generated and distributed
        </span>
      </p>
      <p
        className={styles.ques_heading}
        style={{
          display: "flex",
          marginTop: hide ? "-1rem" : "0rem",
          marginBottom: hide ? "-2rem" : "0rem",
        }}
      >
        a. Direct economic value generated and distributed (EVG&D) on an
        accruals basis, including the basic components for the organization’s
        global operations as listed below. If data are presented on a cash
        basis, report the justification for this decision in addition to
        reporting the following basic components:
      </p>
      <Box sx={{ my: "2rem", ml: "15px" }}>
        {/* {subHeading && <p className={style.subHeading}>{subHeading}</p>} */}
        {inputData?.map((section, tableIndex) => (
          <Box key={section.fieldName} sx={{ marginBottom: "2rem" }}>
            {tableIndex === 1 && downloadMode && (
              <Box sx={{ pageBreakBefore: "always" }}></Box>
            )}
            <Typography
              sx={{
                fontWeight: 600,
                fontStyle: "Inter",
                fontSize: "16px",
                lineHeight: "24px",
                my: 2,
              }}
            >
              {section.title}
            </Typography>
            <Box sx={{ display: "flex", ml: "2rem" }}>
              <Box
                sx={{ marginRight: 2, fontWeight: "bold", marginTop: "0.5rem" }}
              >
                Currency:
              </Box>
              <Select
                // name={section.currencyFieldName}
                // value={formData?.[section.currencyFieldName] || ""}
                name={"valueGeneratedCurrency"}
                value={formData?.valueGeneratedCurrency || ""}
                placeholder="Select"
                onChange={handleCurrencyChange}
                displayEmpty
                size="small"
                sx={{ width: "11%" }}
                disabled={tableIndex >= section.currency.length - 2 || disabled}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                {section?.currency?.map((currencyOption) => (
                  <MenuItem key={currencyOption} value={currencyOption}>
                    {currencyOption}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            {errors ? (
              <FormHelperText sx={{ color: "red", ml: "5rem" }}>
                {errors?.[section.currencyFieldName]}
              </FormHelperText>
            ) : null}
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                mt: "1rem",
                borderRadius: "10px",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {"SNo."}
                    </TableCell>
                    {section.fields?.map((field) => (
                      <TableCell
                        key={field.fieldName}
                        sx={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                        }}
                      >
                        {field.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {defaultSegments?.[tableIndex]?.percentage?.map(
                    (segment, rowIndex) => (
                      <TableRow key={rowIndex}>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            background:
                              segment?.title === "Total" ? "#EFEFEF" : "white",
                          }}
                        >
                          {segment?.title === "Total" ? "" : `${rowIndex + 1}.`}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #DBDBDB",
                            background:
                              segment?.title === "Total" ? "#EFEFEF" : "white",
                            color:
                              segment?.title === "Total" ? "#000" : "#1C5B8D",
                          }}
                        >
                          {segment.title}
                        </TableCell>

                        {section.fields?.slice(0, -1)?.map((field, index) => {
                          const [fieldName, name] =
                            field?.subheading?.split(".");
                          return (
                            <TableCell
                              key={field.fieldName}
                              sx={{
                                border: "1px solid #DBDBDB",
                                py: "0.5rem",
                                width: field.width,
                                maxWidth: field.width,
                                background:
                                  segment?.title === "Total"
                                    ? "#EFEFEF"
                                    : "white",
                              }}
                            >
                              <Box sx={{ minWidth: "100px" }}>
                                <TextField
                                  sx={{ width: "100%" }}
                                  name={`${field.subheading}.${segment.field}`}
                                  value={
                                    tableIndex === inputData.length - 1
                                      ? segment.field === "directeconomic"
                                        ? formData?.valueGenerated?.[
                                            "amount"
                                          ]?.["total"]
                                        : segment.field === "economic"
                                        ? formData?.valueDistributed?.[
                                            "amount"
                                          ]?.["total"]
                                        : parseFloat(
                                            formData?.valueGenerated?.[
                                              "amount"
                                            ]?.["total"]
                                          ) -
                                          parseFloat(
                                            formData?.valueDistributed?.[
                                              "amount"
                                            ]?.["total"]
                                          )
                                      : formData?.[fieldName]?.[name]?.[
                                          segment.field
                                        ]
                                  }
                                  placeholder={
                                    segment?.title === "Total"
                                      ? "0"
                                      : "Enter Number"
                                  }
                                  type={field.type}
                                  multiline
                                  rows={1}
                                  size="small"
                                  variant="standard"
                                  InputProps={{ disableUnderline: true }}
                                  disabled={
                                    tableIndex === inputData.length - 1 ||
                                    segment?.title === "Total" ||
                                    disabled
                                  }
                                  onChange={
                                    segment?.title === "Total" &&
                                    tableIndex === inputData.length - 1
                                      ? undefined
                                      : handleChange
                                  }
                                />
                              </Box>
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ))}
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox
                  url={"/gri"}
                  handleSubmit={handleSubmit}
                  // url1={`/gri/economic-performance/201-2/${id}`}
                />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI201_1;
